import { History, Location } from 'history';
import { tracker } from '../tracker';
import { PageViewedEvent } from '../tracker/events/page-viewed-event';

export class EventRouter {
  private unregister: () => void;

  constructor(private history: History<unknown>) {
    this.unregister = this.listen();
  }

  public track(location: Location<unknown>) {
    // Wait for the document title to be updated
    setTimeout(() => {
      tracker.track(new PageViewedEvent({ location, previousLocation: undefined }));
    }, 1000);
  }

  /**
   * Resets the router, unregistering the block. This should be called after
   * any other component in the application blocks the navigation.
   */
  public reset() {
    this.unregister();
    this.unregister = this.listen();
  }

  private listen() {
    this.track(this.history.location);

    return this.history.listen((location) => {
      this.track(location);
    });
  }
}
